import { FormGroup } from '@angular/forms';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-buscar',
  templateUrl: './buscar.component.html',
  styleUrls: ['./buscar.component.scss']
})
export class BuscarComponent implements OnInit {

  @Input() formGroup: FormGroup;
  @Output() onLimpiar = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  handleLimpiar() {
    this.onLimpiar.emit();
  }

}
